import { ShippingMethod } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Text } from '../../../../../../shared/components/Text';

export const shippingMethodOptionsArray: {
  value: string | number | readonly string[] | undefined;
  display: string | React.ReactElement;
}[] = Object.values(ShippingMethod).map((value) => ({
  value: value,
  display: <Text tId={value} />,
}));
